import React, { useState, useEffect, useContext } from "react";
import { API_TOKEN_NAME, IMAGE_URL } from "../../../constants";
import { scAxiosAdmin } from "../../..";
import Pagination from "react-js-pagination";
import { MyContext } from "../../MyProvider";

const getPackagesLists = async (data) => {
  return await scAxiosAdmin
    .request("/packages/get_package_list", {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
      params: { ...data },
    })
    .then((res) => res.data);
};

const PackageTwo = () => {
  const [allPackages, setAllPackages] = useState([]);
  const [filteredPackages, setFilteredPackages] = useState([]);
  const [filters, setFilters] = useState({
    gender: "",
    age: "",
    department: "",
    pre_exist_condition: "",
  });
  const [pagination, setPagination] = useState({
    total: 0,
    currentPage: 1,
    perPage: 9,
  });

  const context = useContext(MyContext);

  const fetchPackages = () => {
    const data = filters;
    getPackagesLists(data)
      .then((res) => {
        if (res.status) {
          setAllPackages(res.data);
          setFilteredPackages(res.data); // Initially, all data is shown
          setPagination((prev) => ({
            ...prev,
            total: res.data.length,
            currentPage: 1,
          }));
        } else {
          setAllPackages([]);
          setFilteredPackages([]);
        }
      })
      .catch((err) => console.log(err));
  };

  const handlePageChange = (pageNumber) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: pageNumber,
    }));
  };

  const handleFilterChange = (name, value) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // Recalculate filtered packages whenever filters or allPackages change
  useEffect(() => {
    const filteredData = allPackages.filter((pkg) => {
      return (
        (!filters.gender ||
          pkg.gender ===
            String(filters.gender).charAt(0).toUpperCase() +
              String(filters.gender).slice(1)) &&
        (!filters.department || pkg.department_id === filters.department)
      );
    });

    setFilteredPackages(filteredData);
    setPagination((prev) => ({
      ...prev,
      total: filteredData.length,
      currentPage: 1, // Reset to the first page when filters change
    }));
  }, [filters, allPackages]);

  useEffect(() => {
    fetchPackages();
  }, []);

  const indexOfLastItem = pagination.currentPage * pagination.perPage;
  const indexOfFirstItem = indexOfLastItem - pagination.perPage;
  const currentItems = filteredPackages.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  return (
    <div>
      <section className="drop-gender">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-4">
              <div className="btn-group w-100">
                <label
                  className="rounded-3 text-center"
                  style={{
                    backgroundColor: filters.gender ? "#ffffff" : "#0c807d",
                    width: "100%",
                    padding: "8px 10px",
                    color: filters.gender ? "#333" : "#ffffff",
                  }}
                  onClick={() => handleFilterChange("gender", "")}
                >
                  All
                </label>
                <label
                  className="text-center rounded-3"
                  style={{
                    backgroundColor:
                      filters.gender === "male" ? "#0c807d" : "#ffffff",
                    width: "100%",
                    padding: "8px 10px",
                    color: filters.gender === "male" ? "#ffffff" : "#333",
                  }}
                  onClick={() => handleFilterChange("gender", "male")}
                >
                  Male
                </label>
                <label
                  className="text-center rounded-3"
                  style={{
                    backgroundColor:
                      filters.gender === "female" ? "#0c807d" : "#ffffff",
                    width: "100%",
                    padding: "8px 10px",
                    color: filters.gender === "female" ? "#ffffff" : "#333",
                  }}
                  onClick={() => handleFilterChange("gender", "female")}
                >
                  Female
                </label>
              </div>
            </div>
          </div>
          <div className="our-recommendations mt-4">
            <div className="row mt-2">
              {currentItems.length > 0 ? (
                currentItems.map((pkg) => {
                  return (
                    <div key={pkg.slug} className="col-lg-4 col-md-12 mt-4">
                      <a
                        href={`/packages/${pkg.slug}`}
                        style={{ textDecoration: "none" }}
                      >
                        <div className="card">
                          <img
                            className="img-fluid"
                            src={
                              pkg.image
                                ? `${IMAGE_URL}/Packagesimg/${pkg.image}`
                                : `${IMAGE_URL}/Packagesimg/202303221003packages Profile.png`
                            }
                            style={{
                              maxHeight: "177px",
                              objectFit: "cover",
                              objectPosition: pkg.image ? "center" : "top",
                            }}
                            alt="Package"
                          />
                          <div className="card-body">
                            <h5 className="text-capitalize">
                              {pkg.name.split(" ").slice(0, 5).join(" ")}...
                            </h5>
                            <p>BDT {pkg.opd_amount}</p>
                            <div
                              className="px-2 py-1 mt-2 rounded w-50"
                              style={{ backgroundColor: "#0C807D" }}
                            >
                              <a
                                className="d-flex justify-content-center"
                                href={`/packages/${pkg.slug}`}
                                style={{
                                  width: "100%",
                                  color: "#ffffff",
                                  textDecoration: "none",
                                  textAlign: "center",
                                }}
                              >
                                <b className="w-100">More Information</b>
                              </a>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  );
                })
              ) : (
                <div className="col-lg-12 col-md-12">
                  <p>No packages found</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      <Pagination
        className="m-0"
        activePage={pagination.currentPage}
        itemsCountPerPage={pagination.perPage}
        totalItemsCount={pagination.total}
        pageRangeDisplayed={5}
        onChange={handlePageChange}
      />
    </div>
  );
};

export default PackageTwo;



// WEBPACK FOOTER //
// ./src/component/frontend/package/PackageTwo.js